export const PhotoMark = ({ className = "" }) => (
  <img
    src="/logo/cuarto-bolero-logo.png"
    alt=""
    aria-hidden="true"
    className={`pointer-events-none absolute z-10 w-auto select-none drop-shadow-[0_2px_10px_rgba(0,0,0,0.55)] ${className}`}
  />
);
